<div
  class="relative cursor-pointer transition-all duration-200 h-fit"
  [class.hover:opacity-80]="!media.selected">
  <div data-testid="folder_content__menu">
    <span
      class="w-6 h-6 text-center absolute top-1 right-1 cursor-pointer rounded-full box-bg hover:bg-primary"
      (click)="menu.toggle($event); $event.stopPropagation()">
      <i class="pi pi-ellipsis-v" style="font-size: 12px"></i>
    </span>
    <span
      tooltipPosition="top"
      tooltipStyleClass="custom-tooltip"
      showDelay="1500"
      class="w-6 h-6 text-center absolute bottom-1 right-1 cursor-pointer rounded-full box-bg hover:bg-primary"
      pTooltip="File name: {{ media.file_name }}{{ media.extension }} &#13;
        Description: {{ media.description }} &#13;
        Size: {{ (media.file_size || 0) / 1000000 | number: '1.2-2' }} Mb
        "
      (click)="op.toggle($event); $event.stopPropagation()">
      <i class="pi pi-info" style="font-size: 12px"></i>
    </span>
    <p-popover #op>
      <div class="flex flex-col">
        <div class="font-bold mb-3">{{ 'File details' | translate }}:</div>
        <div class="text-gray text-sm">
          <div>{{ 'File name' | translate }}: {{ media.file_name }}{{ media.extension }}</div>
          <div class="max-w-xs break-words whitespace-normal">
            {{ 'Description' | translate }}: {{ media.description }}
          </div>
          <div>
            {{ 'Size' | translate }}:
            {{ (media.file_size || 0) / 1000000 || 0 | number: '1.2-2' }} Mb
          </div>
        </div>
      </div>
    </p-popover>
    <p-menu
      #menu
      data-testid="folder_content__menu-popup"
      [appendTo]="'body'"
      [popup]="true"
      [model]="items">
      <ng-template #start />
      <ng-template #submenuheader let-item>
        @if (item?.visible !== false) {
          <div class="text-blue-500 font-bold" data-testid="folder_content__submenu-header">
            {{ item.label }}
          </div>
        }
      </ng-template>
      <ng-template #item let-item>
        @if (item?.visible !== false) {
          <a
            class="flex items-center p-2 cursor-pointer gap-2"
            data-testid="folder_content__menu-item">
            <span
              class="inline-flex items-center justify-center {{
                item?.icon_color ? item?.icon_color : 'text-blue-500'
              }}">
              <mat-icon fontIcon="{{ item.icon ? item.icon : 'add_circle' }}" />
            </span>
            <span class="inline-flex flex-col gap-2">
              <span class="font-light text-sm">{{ item.label }}</span>
            </span>
          </a>
        }
      </ng-template>
    </p-menu>
  </div>

  @switch (media.media_file_type) {
    @case ('image') {
      <div>
        <div
          class="aspect-[16/9] w-full h-full object-cover"
          [offcononBlurhashImage]="
            media.thumbnail_file_url ? media.thumbnail_file_url : media.media_file_url
          "
          [offcononBlurhash]="media.blur_hash"
          [useHostClasses]="true"></div>
      </div>
    }
    @case ('video') {
      <div class="break-all">
        @if (!playVideo && media.thumbnail_file_url) {
          <span
            class="w-6 h-6 text-center absolute top-1 left-1 cursor-pointer rounded-full box-bg hover:bg-primary"
            (click)="playVideo = true; $event.stopPropagation()">
            <i class="pi pi-play" style="font-size: 12px"></i>
          </span>
          <div
            [offcononBlurhashImage]="media.thumbnail_file_url"
            [offcononBlurhash]="media.blur_hash"></div>
        } @else {
          <video controls autoplay muted>
            <source type="video/mp4" [src]="media.media_file_url" />
            <source type="video/avi" [src]="media.media_file_url" />
            <source type="video/webm" [src]="media.media_file_url?.replace('.mp4', '.webm')" />
            <source type="video/ogg" [src]="media.media_file_url?.replace('.mp4', '.ogv')" />
            {{ 'Your browser does not support the video tag.' | translate }}
          </video>
        }
        <div></div>
      </div>
    }
    @case ('audio') {
      <div
        class="bg-gray rounded-lg px-1 flex flex-col break-all aspect-[16/9] items-center justify-center">
        <audio
          alt="Selectable"
          controls
          [src]="media.media_file_url"
          [muted]="media.selected"></audio>
      </div>
    }
    @case ('document') {
      <div
        class="bg-gray rounded-lg px-3 break-words flex flex-col items-center justify-center aspect-[16/9] max-w-full overflow-hidden">
        <div class="items-center justify-center">
          <i style="font-size: 42px" class="pi pi-{{ iconName }}"></i>
        </div>
        <div
          class="items-center justify-center break-words text-center overflow-wrap text-ellipsis truncate w-full text-xs">
          {{ media.file_name }}{{ media.extension }}
        </div>
      </div>
    }
    @case ('other') {
      <div
        class="bg-gray rounded-lg break-words flex flex-col items-center justify-center aspect-[16/9] max-w-full overflow-hidden">
        <div class="items-center justify-center">
          <i style="font-size: 42px" class="pi pi-question"></i>
        </div>
        <div
          class="items-center justify-center break-words text-center overflow-wrap text-ellipsis truncate max-w-64">
          {{ media.file_name }}{{ media.extension }}
        </div>
      </div>
    }
    @case ('zip') {
      <div
        class="hover:bg-gray-300 dark:hover:bg-gray-700 break-words flex flex-col items-center justify-center aspect-[16/9] max-w-full overflow-hidden">
        <div class="items-center justify-center">
          <i style="font-size: 42px" class="pi pi-file"></i>
        </div>
        <div
          class="items-center justify-center break-words text-center overflow-wrap text-ellipsis truncate max-w-64">
          {{ media.file_name }}{{ media.extension }}
        </div>
      </div>
    }
  }
  @if (media.selected) {
    <div class="bg-blue-500 rounded-full p-1 box-icon icon-absolute-center">
      <i class="pi pi-check"></i>
    </div>
  }
</div>
<p-dialog
  header="{{ 'Select a folder' | translate }}"
  [modal]="true"
  [closeOnEscape]="true"
  [resizable]="true"
  [closable]="true"
  [dismissableMask]="true"
  [maximizable]="true"
  [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [(visible)]="selectFolder"
  (onHide)="closeDialog()">
  @if (selectFolder) {
    <offconon-folder-tree
      [folderList]="folderList"
      [selected_file_id]="media.id"
      [copyAction]="copyAction"
      [selected_file_album_id]="media.album_id"
      (MovedFilesEmit)="closeDialog()" />
  }
</p-dialog>
<p-dialog
  header="{{ 'Edit file properties' | translate }}"
  [modal]="true"
  [closeOnEscape]="true"
  [resizable]="true"
  [closable]="true"
  [dismissableMask]="true"
  [maximizable]="true"
  [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [(visible)]="editProperty"
  (onHide)="closePropertiesDialog()">
  <div class="p-2">
    <div class="pt-3">
      @if (editProperty) {
        <offconon-file-properties-form [data]="media" (formSavedEvent)="savedProperties($event)" />
      }
    </div>
  </div>
</p-dialog>
<p-confirmDialog
  [key]="'deleteMediaDialogCard-' + media.id"
  [breakpoints]="{ '960px': '75vw' }"
  [baseZIndex]="12"
  [appendTo]="'body'">
  <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
    <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
      <span class="font-bold text-2xl block mb-2 mt-6">{{ message?.header }}</span>
      <p class="mb-0">{{ message?.message }}</p>
      <div class="flex items-center gap-2 mt-6">
        <p-button label="{{ 'Yes, I want to delete it.' | translate }}" (onClick)="onAccept()" />
        <p-button label="{{ 'Cancel' | translate }}" [outlined]="true" (onClick)="onReject()" />
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
